"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileView = ProfileView;
var _litHtml = require("lit-html");
require("./styles/ProfileView.css");
var _ChatWithMe = require("./ChatWithMe");
var _FriendList = require("./FriendList");
var _presenter = require("./presenter");
var _CVPresenter = require("./CVPresenter");
var _SocialPresenter = require("./SocialPresenter");
var _StuffPresenter = require("./StuffPresenter");
var _ProfileCard = require("./ProfileCard");
var _CVCard = require("./CVCard");
var _SocialCard = require("./SocialCard");
var _StuffCard = require("./StuffCard");
var _texts = require("./texts");
// 20210527
// 20210527
// 20210527

// The edit button switches to the editor pane
/*
function renderEditButton (subject) {
  return 
    authn.currentUser() && authn.currentUser().sameTerm(subject) ?
        html `<button type="button" class="ProfilePaneCVEditButton">
        <img  src="${editButtonURI}">
        Edit</button>`
    : html``;
}
*/

async function ProfileView(subject, context) {
  const store = context.session.store;
  const profileBasics = (0, _presenter.presentProfile)(subject, store);
  const rolesByType = (0, _CVPresenter.presentCV)(subject, store);
  const accounts = (0, _SocialPresenter.presentSocial)(subject, store);
  const stuffData = await (0, _StuffPresenter.presentStuff)(subject);
  return (0, _litHtml.html)` 
    <main
      id="main-content"
      class="profile-grid"
      style="--profile-grid-bg: radial-gradient(circle, ${profileBasics.backgroundColor} 80%, ${profileBasics.highlightColor} 100%)"
      role="main"
      aria-label="Profile for ${profileBasics.name}"
      tabindex="-1"
    > 

      <article 
        aria-labelledby="profile-card-heading" 
        class="profileSection section-bg" 
        role="region"
        tabindex="-1"
      >
        <header class="text-center mb-md">
          <h2 id="profile-card-heading" tabindex="-1">${profileBasics.name}</h2>
        </header>
        ${(0, _ProfileCard.ProfileCard)(profileBasics, context, subject)}
      </article>

      ${(() => {
    const cv = (0, _CVCard.CVCard)(rolesByType);
    return cv && cv.strings && cv.strings.join('').trim() !== '' ? (0, _litHtml.html)`
          <section 
            aria-labelledby="cv-heading" 
            class="profileSection section-bg" 
            role="region"
            tabindex="-1"
          >
            <header class="text-center mb-md">
              <h2 id="cv-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
            </header>
            <div>
              ${cv}
            </div>
          </section>
        ` : '';
  })()}

      ${accounts.accounts && accounts.accounts.length > 0 ? (0, _litHtml.html)`
        <aside 
          aria-labelledby="social-heading" 
          class="profileSection section-bg" 
          role="complementary"
          tabindex="-1"
        >
          <header class="text-center mb-md">
            <h2 id="social-heading" tabindex="-1">${_texts.socialAccountsHeadingText}</h2>
          </header>
          <nav aria-label="Social media links">
            ${(0, _SocialCard.SocialCard)(accounts)}
          </nav>
        </aside>
      ` : ''}

      ${stuffData.stuff && stuffData.stuff.length > 0 ? (0, _litHtml.html)`
        <section 
          aria-labelledby="stuff-heading" 
          class="profileSection section-bg" 
          role="region"
          tabindex="-1"
        >
          <header class="text-center mb-md">
            <h2 id="stuff-heading" tabindex="-1">${_texts.sharedItemsHeadingText}</h2>
          </header>
          <div>
            ${(0, _StuffCard.StuffCard)(profileBasics, context, subject, stuffData)}
          </div>
        </section>
      ` : ''}

      ${(() => {
    const friends = (0, _FriendList.FriendList)(subject, context);
    return friends ? (0, _litHtml.html)`
          <aside 
            aria-labelledby="friends-heading" 
            class="profileSection section-bg" 
            role="complementary"
            tabindex="-1"
          >
            <header class="text-center mb-md">
              <h2 id="friends-heading" tabindex="-1">${_texts.friendsHeadingText}</h2>
            </header>
            <div role="list" aria-label="Friend connections">
              ${friends}
            </div>
          </aside>
        ` : '';
  })()}

      <section 
        aria-labelledby="chat-heading" 
        class="profileSection section-bg" 
        role="region"
        tabindex="-1"
      >
        <header class="text-center mb-md">
          <h2 id="chat-heading" tabindex="-1">${_texts.contactHeadingText}</h2>
        </header>
        <div>
          ${(0, _ChatWithMe.ChatWithMe)(subject, context)}
        </div>
      </section>
    </main>
  `;
}